<template>
  <div class="modal fade"id="modalInvoicePopup" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="modalInvoicePopupLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalInvoicePopupLabel">Fatura Detayları</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <v-wait for="invoice-detail-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Fatura detayları yükleniyor...</p>
              </div>
            </template>
            <div class="container-fluid mb-3">
              <div class="form-row mb-2">
                <label for="invoiceDate">Fatura Tarihi</label>
                <input id="invoiceDate" type="date" v-model="invoiceModel.InvoiceDateDBType" class="form-control">
              </div>
              <div class="form-row mb-2">
                <label for="invoiceTitle">Fatura Açıklaması</label>
                <input id="invoiceTitle" type="text" v-model="invoiceModel.InvoiceTitle" class="form-control">
              </div>
              <div class="form-row mb-2">
                <label for="invoiceNumber">Fatura Numarası</label>
                <input id="invoiceNumber" type="number" v-model="invoiceModel.InvoiceId" class="form-control">
              </div>
              <div class="form-row mb-2">
                <label for="invoiceAmount">Fatura Tutarı</label>
                <input id="invoiceAmount" type="number" v-model="invoiceModel.InvoiceAmount" class="form-control">
              </div>
              <div class="form-row mb-2">
                <label for="invoiceLength">Fatura Kapsamı</label>
                <input id="invoiceLength" type="number" v-model="invoiceModel.InvoiceLength" class="form-control">
              </div>
              <div class="form-row mb-2">
                <label for="invoiceStatus">Fatura Durumu</label>
                <select id="invoiceStatus" v-model="invoiceModel.InvoiceStatus" class="form-control">
                  <option value="false">Ödenmedi</option>
                  <option value="true">Ödendi</option>
                </select>
              </div>
            </div>
          </v-wait>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
          <button class="btn btn-success" type="button">
            <i class="mr-2 fas fa-check text-white"></i>{{invoiceId == 0 ? 'Faturayı Kaydet' : 'Faturayı Güncelle'}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: 'InvoicePopupPage',
  data() {
    return {
      invoiceId: 0,
      invoiceModel: {}
    }
  },
  methods: {
    setInvoiceData(id, obj) {
      if(id == -1) return;

      this.invoiceId = id
      this.invoiceModel = obj
    }
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/partials/InvoicePopupPage.vue